import DishReviewChoices from "./DishReviewChoices";

export default DishReviewChoices;
